import { render, staticRenderFns } from "./buyGoldSend.vue?vue&type=template&id=8d4e3d16&scoped=true"
import script from "./buyGoldSend.vue?vue&type=script&lang=js"
export * from "./buyGoldSend.vue?vue&type=script&lang=js"
import style0 from "./buyGoldSend.vue?vue&type=style&index=0&id=8d4e3d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4e3d16",
  null
  
)

export default component.exports